import React from "react";
import { Modal } from "react-bootstrap";
import Loading from "./Loading";

const ModalLoading = ({ isLoading, isLoadingInmueble }) => {
    return (
        <Modal
            show={isLoading || isLoadingInmueble}
            centered
        >
            <Modal.Body className="d-flex justify-content-center align-items-center">
                {isLoading && <Loading />}
                {isLoadingInmueble && <Loading />}
            </Modal.Body>
        </Modal>
    );
}

export default ModalLoading;
